import React, { useCallback } from 'react';
import { NuvoMenuItem } from '@nuvolo/nuux-core/components/NuvoMenuItem';
import { useNavigate } from 'react-router-dom';
import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { NuvoText } from '@nuvolo/nuux-core/components/NuvoText';
import { ACTIVE_COLOR, INACTIVE_COLOR } from './Styles';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import MobileActiveMarker from './MobileActiveMarkter';
import FAIcon from '#/common/components/FAIcon';

export interface MenuItemProps {
  label: string;
  route: string;
  icon: string;
  isActive?: boolean;
  filled?: boolean;
  desktopOnly?: boolean;
  onClick?: () => void;
  shouldShow?: boolean;
  collapsed?: boolean;
}

const activeColor = ACTIVE_COLOR;
const inactiveColor = INACTIVE_COLOR;

const MenuItem: React.FC<MenuItemProps> = (props) => {
  const { label, route, icon, isActive, desktopOnly, onClick, filled = true, collapsed } = props;
  const navigate = useNavigate();
  const { isMobile } = useViewport();

  const action = useCallback(() => {
    if (onClick) {
      return onClick();
    }
    navigate(route);
  }, [navigate, route, onClick]);

  if (isMobile && desktopOnly) {
    return null;
  }

  return (
    <NuvoMenuItem
      action={action}
      label={
        <NuvoBox
          style={{ position: 'relative', height: '52px', boxSizing: 'border-box' }}
          display="flex"
          width="100%"
          flexDirection={!isMobile && !collapsed ? 'row' : 'column'}
          alignItems="center"
          justifyContent={!isMobile && !collapsed ? 'flex-start' : 'center'}
          paddingX={!isMobile && !collapsed ? '16px' : undefined}
          gap={!isMobile && !collapsed ? '12px' : '5px'}>
          {isMobile && isActive && <MobileActiveMarker />}
          <NuvoBox display="flex" alignItems="center" justifyContent="center">
            <FAIcon icon={icon} size="xl" color={isActive ? activeColor : inactiveColor} />
          </NuvoBox>
          {!collapsed && (
            <NuvoText type="body" color={isActive ? activeColor : inactiveColor}>
              {label}
            </NuvoText>
          )}
        </NuvoBox>
      }
    />
  );
};

export default React.memo(MenuItem);
